export default __webpack_public_path__ + "static/media/Car.b9541b82.svg";